import * as types from '../mutation-types'
import req from '../../lib/authRequest'
import store from '../index'

/*
 * Vuex module to handle authorized contact related data
 */

const state = {
  authorized_contacts: [],
  temp_contact: {},
  editing_contact: {
    city: '',
    cmp_name: '',
    comments: '',
    cntid: '0',
    dob: '',
    email: '',
    fax: '',
    line1: '',
    line2: '',
    mobile: '',
    name: '',
    phone: '',
    position: '',
    state: '',
    title: '',
    zip_code: '',
    zip_ext: ''
  },
  editing_ldap: {uid: '', password: ''},
  editing_perms: {
    account : {'has_manage': false, 'has_view': false},
    admin   : {'has_manage': false, 'has_view': false},
    contacts: {'has_manage': false, 'has_view': false},
    invoices: {'has_manage': false, 'has_view': false},
    payments: {'has_manage': false, 'has_view': false},
    services: {'has_manage': false, 'has_view': false}
  },
  edit_mode: false,
  // Possible options for address and reminder types
  address_types: [{label: 'Business', value: '1'}, {label: 'Home', value: '2'}],
  reminder_types: [{label: 'Fax', value: '3'}, {label: 'E-Mail', value: '1'}, {label: 'CC Auto', value: '4'}, {label: 'Snail Mail', value: '2'}]
}

const mutations = {
  [types.SET_AUTHORIZED_CONTACTS] (state, authorizedContacts) {
    state.authorized_contacts = authorizedContacts
  },
  [types.BEGIN_EDIT_CONTACT] (state) {
    state.temp_contact = JSON.parse(JSON.stringify(state.editing_contact))
    state.edit_mode = true
  },
  [types.CANCEL_EDIT_CONTACT] (state) {
    state.edit_mode = false
    if (Object.keys(state.temp_contact).length > 0) {
      state.editing_contact = JSON.parse(JSON.stringify(state.temp_contact))
      state.temp_contact = {}
    }
  },
  [types.SET_EDITING_CONTACT] (state, contact) {
    state.editing_contact = contact
    // state.editing_contact.dob = new Date(state.editing_contact.dob)
  },
  [types.SET_EDITING_LDAP] (state, ldap_data) {
    state.editing_ldap = ldap_data
  },
  [types.SET_EDITING_PERMS] (state, perms_data) {
    state.editing_perms = perms_data
  },
  [types.UPDATE_EDITING_CONTACT] (state, { name, value }) {
    let temp = state.editing_contact
    temp[name] = value
    state.editing_contact = temp
  },
}

const actions = {
  /*
   * Get the list of authorized contacts for this account
   */
  getAuthorizedContacts ({ commit }) {
    return new Promise((resolve, reject) => {
      req.get({
        url: '/user/authorized_contacts',
        success (result) {
          // Add a combined name variable
          commit(types.SET_AUTHORIZED_CONTACTS, result)
          resolve()
        }
      })
    })
  },

  createNewContact ({ commit, state, dispatch }, newContact) {
    return new Promise((resolve, reject) => {
      req.post({
        url: '/user/' + (store.getters.hasAdminPerm ? 'admin_' : '') + 'authorized_contacts',
        data: newContact,
        notifications: false,
        modalNotifications: true,
        success (result) {
          dispatch('getAuthorizedContacts')
          resolve()
        },
        error (result) {
          resolve()
        }
      })
    })
  },

  createNewUser ({ commit, state, dispatch }, newContact) {
    return new Promise((resolve, reject) => {
      req.post({
        url: '/user/' + (store.getters.hasAdminPerm ? 'admin_' : '') + 'authorized_users',
        data: newContact,
        notifications: false,
        modalNotifications: true,
        success (result) {
          dispatch('getAuthorizedContacts')
          resolve(result)
        },
        error (result) {
          resolve(result)
        }
      })
    })
  },

  getEditingContact ({ commit }, contact_id) {
    return new Promise((resolve, reject) => {
      req.get({
        url: '/user/authorized_contact?contact_id=' + contact_id,
        success (result) {
          // Add a combined name variable
          result.billing['contact_id'] = contact_id
          commit(types.SET_EDITING_CONTACT, result.billing)
          resolve()
        }
      })
    })
  },

  getEditingUser ({ commit }, { contact_id, uid }) {
    return new Promise((resolve, reject) => {
      req.get({
        url: '/user/authorized_users?contact_id=' + contact_id + '&uid=' + uid,
        notifications: false,
        modalNotifications: true,
        success (result) {
          // Add a combined name variable
          result.billing['contact_id'] = contact_id
          commit(types.SET_EDITING_CONTACT, result.billing)
          commit(types.SET_EDITING_LDAP, result.ldap)
          commit(types.SET_EDITING_PERMS, result.db)
          resolve()
        },
      })
    })
  },

  saveEditingContact ({ commit, state, dispatch }, contact) {
    return new Promise((resolve, reject) => {
      req.patch({
        url: '/user/' + (store.getters.hasAdminPerm ? 'admin_' : '') + 'authorized_contacts/' + contact.contact_id,
        data: contact,
        notifications: false,
        modalNotifications: true,
        success (result) {
          dispatch('getAuthorizedContacts')
          resolve()
        },
        error (result) {
          reject(result)
        }
      })
    })
  },

  saveEditingUser ({ commit, state, dispatch }, contact) {
    return new Promise((resolve, reject) => {
      req.patch({
        url: '/user/' + (store.getters.hasAdminPerm ? 'admin_' : '') + 'authorized_users/' + contact.contact_data.contact_id,
        data: contact,
        notifications: false,
        modalNotifications: true,
        success (result) {
          dispatch('getAuthorizedContacts')
          resolve()
        },
        error (result) {
          reject(result)
        }
      })
    })
  },

  convertContactToUser( {commit, dispatch}, contact ) {
    return new Promise((resolve, reject) => {
      contact['add_perms'] = true;
      req.put({
        url: '/user/' + (store.getters.hasAdminPerm ? 'admin_' : '') + 'authorized_users/' + contact.contact_id,
        data: contact,
        notifications: true,
        modalNotifications: false,
        success (result) {
          resolve()
        },
        error (result) {
          reject(result)
        }
      })
    })
  },
  convertUserToContact( {commit, dispatch}, contact ) {
    return new Promise((resolve, reject) => {
      contact['add_perms'] = false;
      req.put({
        url: '/user/' + (store.getters.hasAdminPerm ? 'admin_' : '') + 'authorized_users/' + contact.contact_id,
        data: contact,
        notifications: true,
        modalNotifications: false,
        success (result) {
          resolve()
        },
        error (result) {
          reject(result)
        }
      })
    })
  },
  deleteContact ({ commit, dispatch }, contact) {
    return new Promise((resolve, reject) => {
      req.delete({
        url: '/user/' + (store.getters.hasAdminPerm ? 'admin_' : '') + 'authorized_contacts/' + contact.contact_id,
        success (result) {
          dispatch('getAuthorizedContacts')
          resolve()
        },
        error (result) {
          reject()
        }
      })
    })
  },
  deleteUser ({ commit, dispatch }, contact) {
    return new Promise((resolve, reject) => {
      req.delete({
        url: '/user/' + (store.getters.hasAdminPerm? 'admin_' : '') + 'authorized_users/' + contact.contact_id + '?uid=' + contact.uid,
        notifications: true,
        modalNotifications: false,
        success (result) {
          dispatch('getAuthorizedContacts')
          resolve()
        },
        error (result) {
          reject()
        }
      })
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/contacts.js